





































































































import { Component, Vue } from "vue-property-decorator";
import sidebar from "@/components/englishjanala/sidebar.vue";
import ConversationIcon from "@/components/svgicon/ConversationSVG.vue";
import WordsIcon from "@/components/svgicon/WordsSVG.vue";
import GrammarIcon from "@/components/svgicon/GrammarSVG.vue";
import HeadphonSVG from "@/components/svgicon/HeadphonSVG.vue";
// import { Chapter } from "@/model/englishjanala/englishjanala.ts";
import NewChapter from "@/components/modals/NewChapter.vue";
import * as data from "@/model/englishjanala/englishjanala.json";
import Chapter from "./Chapter.vue";
// import ExerciseList from "@/components/cards/ExerciseList.vue";
import ExerciseList from "@/components/cards/word/ExerciseList.vue";
import axios from "axios";
import { Notify, Dialog } from "vant";
import Spiner from "@/components/englishjanala/Spiner.vue";
import EditChapter from "@/components/modals/EditChapter.vue";
/* eslint-disable @typescript-eslint/class-name-casing */
/* eslint-disable @typescript-eslint/camelcase */
@Component({
  components: {
    sidebar,
    ConversationIcon,
    WordsIcon,
    GrammarIcon,
    HeadphonSVG,
    NewChapter,
    ExerciseList,
    Spiner,
    EditChapter,
  },
})
export default class Home extends Vue {
  ConvId: any;
  Spiner: boolean = true;
  chap: any;
  show: boolean = false;
  ChapterId = -1;
  Chapters: any = null;

  MouseHover(ChapterId: any) {
    this.ChapterId = ChapterId;
  }
  get ConversationId() {
    this.ConvId = this.$route.params.ConversationId;
    return this.$route.params.ConversationId;
  }

  NewChapter(chapter: any) {
    // alert("hi");
    this.Chapters.push({
      name: chapter.name,
      id: chapter.id,
      imageUrl: chapter.imageUrl,
      contributorName: chapter.contributorName,
      exercise: {
        name: "",
        id: "",
        numberQuestionsSelected: 0,
        description: "",
        shortDescription: "",
      },
    });
    const RequestedData = {
      category_id: this.ConversationId,
      chapter: {
        name: chapter.name,
        id: chapter.id,
        imageUrl: chapter.imageUrl,
        contributorName: chapter.contributorName,
        exercise: {
          name: "",
          id: "",
          numberQuestionsSelected: 0,
          description: "",
          shortDescription: "",
        },
      },
    };
    const response = axios
      .post(
        "https://api.englishjanala.com:8443/v1/englishjanala/conversation/ConversationService/AddConversationChapter",
        RequestedData
      )
      .then()
      .catch((error) => {
        Notify({ type: "danger", message: "Chapter is not added" });
      });
    Notify({ type: "success", message: "Chapter added" });
    chapter.name = chapter.id = chapter.imageUrl = chapter.contributorName = "";
    window.scrollTo(0, document.body.scrollHeight);
  }

  getImgUrl(item: any) {
    return item.imageUrl;
  }
  async DeleteConversation(id: string, index: string) {
    // location.reload();
    Dialog.confirm({
      title: "Delete",
      message: "Are you sure?",
      cancelButtonText: "No",
      confirmButtonText: "Yes",
    })
      .then(() => {
        const PassData = { category_id: this.ConversationId, chapter_id: id };
        const response = axios
          .post(
            "https://api.englishjanala.com:8443/v1/englishjanala/conversation/ConversationService/DeleteConversationChapter",
            PassData
          )
          .then()
          .catch((error) => {
            Notify({ type: "danger", message: "Chapter is not deleted" });
          });
        this.$delete(this.Chapters, index);
        Notify({ type: "success", message: "Chapter deleted" });
      })
      .catch(() => {
        // on cancel
      });
  }
  async mounted() {
    const catId = this.ConversationId;
    const categoryID = { category_id: catId };

    // get all category list
    const response = await axios.post(
      "https://api.englishjanala.com:8443/v1/englishjanala/conversation/ConversationService/GetConversationChapterList",
      categoryID
    );
    const data = response.data;
    this.Chapters = data.chapters;
    console.log("conver", data.chapters);
    console.log("res dat", response.data);
    this.Spiner = false;
  }
  EditConversation(index: any) {
    const modal_id = "EditModal_" + index;
    this.$refs[modal_id][0].showPopup();
  }
}
